import axios from 'axios';

import { Country } from './types';

import { COUNTRIES } from '../endpoints';

export const getCountries = () => axios.get<Country[]>(COUNTRIES);
